import { render, staticRenderFns } from "./agente-aprendizaje.vue?vue&type=template&id=4104b382&scoped=true"
import script from "./agente-aprendizaje.vue?vue&type=script&lang=js"
export * from "./agente-aprendizaje.vue?vue&type=script&lang=js"
import style0 from "./agente-aprendizaje.vue?vue&type=style&index=0&id=4104b382&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4104b382",
  null
  
)

export default component.exports